export default __webpack_public_path__ + "static/media/century21logo.0373d613.png";